import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashRevealComponent } from './smash-reveal/smash-reveal.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';
import { SmashThemeTrackingComponent } from '@app/shared/modules/smash-theme/smash-theme-tracking/smash-theme-tracking.component';

@NgModule({
  declarations: [SmashRevealComponent, SmashThemeTrackingComponent],
  imports: [
    CommonModule,
    SharedModule,
    SmashPlayerComponent,
  ],
  exports: [
    SmashRevealComponent,
    SmashThemeTrackingComponent,
  ]
})
export class SmashThemeModule { }
